/* Wangenschuh24 Theme — Global JS */

// Cart drawer
function openCart() {
  document.getElementById('cart-drawer').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  refreshCart();
}
function closeCart() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

async function refreshCart() {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  const body = document.getElementById('cart-drawer-body');
  const countEls = document.querySelectorAll('.cart-count');
  countEls.forEach(el => el.textContent = '(' + cart.item_count + ')');

  if (cart.item_count === 0) {
    body.innerHTML = '<p class="cart-empty-msg">Ihr Warenkorb ist leer.</p>';
    document.getElementById('cart-drawer-footer').innerHTML = '';
    return;
  }

  let html = '';
  cart.items.forEach(item => {
    html += `<div class="cart-item">
      <img src="${item.image}" alt="${item.title}" />
      <div>
        <div class="cart-item-title">${item.product_title}</div>
        <div class="cart-item-price">${item.variant_title || ''} &mdash; ${(item.price / 100).toFixed(2).replace('.', ',')} €</div>
        <div style="margin-top:0.5rem;display:flex;align-items:center;gap:0.75rem;">
          <button onclick="updateCart('${item.key}', ${item.quantity - 1})" style="background:none;border:1px solid var(--ws-line);width:28px;height:28px;cursor:pointer;font-size:1rem;">−</button>
          <span style="font-family:'IBM Plex Mono',monospace;font-size:13px;">${item.quantity}</span>
          <button onclick="updateCart('${item.key}', ${item.quantity + 1})" style="background:none;border:1px solid var(--ws-line);width:28px;height:28px;cursor:pointer;font-size:1rem;">+</button>
        </div>
      </div>
    </div>`;
  });

  body.innerHTML = html;
  document.getElementById('cart-drawer-footer').innerHTML = `
    <div class="cart-total">
      <span>GESAMT</span>
      <span>${(cart.total_price / 100).toFixed(2).replace('.', ',')} €</span>
    </div>
    <p style="font-size:0.75rem;color:var(--ws-muted);margin-bottom:1rem;font-family:'IBM Plex Mono',monospace;">Inkl. MwSt. · Versandkosten an der Kasse</p>
    <a href="/checkout" class="cart-checkout-btn">Zur Kasse →</a>
  `;
}

async function updateCart(key, qty) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  });
  refreshCart();
}

async function addToCart(variantId, qty) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty || 1 })
  });
  if (res.ok) openCart();
}

document.addEventListener('DOMContentLoaded', function() {
  // Cart icon click
  const cartIcon = document.getElementById('cart-icon');
  if (cartIcon) cartIcon.addEventListener('click', openCart);

  // Overlay click closes cart
  const overlay = document.getElementById('cart-overlay');
  if (overlay) overlay.addEventListener('click', closeCart);

  // Close button
  const closeBtn = document.getElementById('cart-close');
  if (closeBtn) closeBtn.addEventListener('click', closeCart);

  // Mobile menu toggle
  const menuToggle = document.getElementById('menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('open');
    });
  }

  // Initial cart count
  fetch('/cart.js').then(r => r.json()).then(cart => {
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = '(' + cart.item_count + ')';
    });
  });

  // Add to cart buttons
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', function() {
      addToCart(this.dataset.variantId);
    });
  });
});
